export const getUserById = (id, users) => users.find((user) => user._id === id);
